import { pushTo } from '@app/core/routing';
import { FragmentSocialUploadItemDto } from '@app/modules/fragments/fragment.types';
import { routeGenerator } from '@app/modules/fragments/routing/FragmentsRoutes';
import { socialPlatforms } from '@app/modules/social-export/domain/platforms';
import { useSocialExportUploadCardActions } from '@app/modules/social-export/publish/useSocialExportUploadCardActions';
import { socialExport } from '@mi-front/api-clients';
import { webAppGetFragmentSocialUploadsByFragmentIdQueryKey } from '@mi-front/api-v2';
import { useQueryClient } from '@tanstack/react-query';
import { useFragment } from '../../hooks/useFragment';

export interface UseSocialExportUploadItemCardActionsParams {
  upload: FragmentSocialUploadItemDto;
}

/**
 * Fragment upload card actions: wires shared menu/dialog logic to fragment queries and routes.
 */
export function useSocialExportUploadItemCardActions({
  upload,
}: UseSocialExportUploadItemCardActionsParams) {
  const { fragment } = useFragment();
  const queryClient = useQueryClient();
  const platform = socialPlatforms.get(upload.platform);

  return useSocialExportUploadCardActions({
    upload,
    onRetry: () => {
      pushTo(routeGenerator.upload(fragment, platform));
    },
    onDeleteSuccess: async (uploadId: string) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: webAppGetFragmentSocialUploadsByFragmentIdQueryKey(fragment.id),
        }),
        queryClient.invalidateQueries({
          queryKey: socialExport.getUploadQueryKey(uploadId),
        }),
      ]);
    },
    onPromoteSuccess: async (uploadId: string) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: webAppGetFragmentSocialUploadsByFragmentIdQueryKey(fragment.id),
        }),
        queryClient.invalidateQueries({
          queryKey: socialExport.getUploadQueryKey(uploadId),
        }),
      ]);
    },
  });
}
